import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
// ==========================================================================
// ✅ ASYNC THUNKS
// ==========================================================================
// Fetch LTV Report
export const fetchLTVReport = createAsyncThunk("ltv/fetchReport", async (payload, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        // const cacheKey = await generateCacheKey("ltv_report_v2", payload);
        // const cachedData = await getCache(cacheKey);
        // if (cachedData) return cachedData;
        const response = await ApiCall("POST", "/api/customer-acquisition/monthly-ltv-report", // 👈 tera backend route
        payload, {
            Authorization: token || "",
            "x-module-key": 'ltv_report'
        });
        // ApiCall does NOT throw on non-2xx — it resolves with the AxiosError
        // object instead. So a 404/500/etc. arrives here as `response`, not in
        // the catch block. Detect that shape and reject with the server's
        // message so the slice's `rejected` reducer surfaces it as reportError.
        const errLike = response;
        // Error status can sit on `.response.status` (AxiosError) or `.status`
        // (a raw response ApiCall returns in some auth branches).
        const status = errLike?.response?.status ?? errLike?.status;
        const serverMessage = errLike?.response?.data?.message ?? errLike?.data?.message;
        if (!response || errLike?.isAxiosError || (typeof status === "number" && status >= 400)) {
            if (status === 404) {
                return rejectWithValue(serverMessage ||
                    "No LTV report found for the selected client and period.");
            }
            return rejectWithValue(serverMessage ||
                errLike?.message ||
                "An error occurred while fetching LTV report");
        }
        if (response && 'data' in response && response?.data) {
            const responseData = response.data?.data;
            const finalData = {
                last_updated: responseData?.last_updated_at || null,
                results: responseData || []
            };
            // setCache(cacheKey, finalData, 300);
            return finalData;
        }
        // Reached only on an unexpected empty-but-ok response — treat as error
        // rather than silently fulfilling with undefined.
        return rejectWithValue("Unexpected empty response while fetching LTV report");
    }
    catch (error) {
        console.error("LTV Report API Error:", error);
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "An error occurred while fetching LTV report");
    }
});
// ✅ Initial State
const initialState = {
    reportData: null,
    reportLoading: false,
    reportError: null,
};
// ==========================================================================
// ✅ SLICE
// ==========================================================================
const ltvSlice = createSlice({
    name: "ltv",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // ========== LTV REPORT ==========
        builder
            .addCase(fetchLTVReport.pending, (state) => {
            state.reportLoading = true;
            state.reportError = null;
        })
            .addCase(fetchLTVReport.fulfilled, (state, action) => {
            state.reportLoading = false;
            state.reportData = action.payload;
            state.reportError = null;
        })
            .addCase(fetchLTVReport.rejected, (state, action) => {
            state.reportLoading = false;
            state.reportError = action.payload || "Failed to fetch report";
        });
    },
});
// ✅ Selectors
export const selectLTVReportData = (state) => state.ltv.reportData;
export const selectLTVReportLoading = (state) => state.ltv.reportLoading;
export const selectLTVReportError = (state) => state.ltv.reportError;
// Export the reducer to be included in the store
export default ltvSlice.reducer;
